module.exports = __webpack_public_path__ + "img/logo-jobboardy.82ffe0af.svg";